export default function ConsultantCardSkeleton() {
  return (
    <div className="bg-white rounded-2xl p-8 h-92 w-83 flex flex-col items-center justify-center animate-pulse">
      <div className="w-32 h-32 rounded-full bg-gray-200 mb-6" />
      <div className="h-4 w-32 bg-gray-200 rounded" />
    </div>
  );
}